import React, {ReactNode} from 'react';
import {Box, Paper, Typography} from '@mui/material';


export type ErrorPageProps = {
    title: string,
    header?: string,
    description?: string,
    action: ReactNode,
};

export function ErrorPage({title, header, description, action}: ErrorPageProps) {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '60vh',
            }}
        >
            <Paper
                elevation={3}
                sx={{
                    p: 5,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    maxWidth: 600,
                }}
            >
                <Typography variant="h3" color="primary" sx={{mb: 2, textAlign: 'center'}}>
                    {title}
                </Typography>
                {header && (
                    <Typography variant="subtitle1" sx={{mb: 1}}>
                        {header}
                    </Typography>
                )}
                {description && (
                    <Typography variant="body1" sx={{mb: 4, textAlign: 'center', whiteSpace: 'pre-wrap'}}>
                        {description}
                    </Typography>
                )}
                {action}
            </Paper>
        </Box>
    );
}